import { BaseContainerModel } from '../base-container.model';

import {
  bl_pgw_contract_rate_hdr_RowClass,
  bl_pgw_contract_rate_hdr_RowInterface
} from '../../dbschema';

export class PGWContractRateContainerModel extends BaseContainerModel {
  bl_pgw_contract_rate_hdr: bl_pgw_contract_rate_hdr_RowInterface = new bl_pgw_contract_rate_hdr_RowClass();
}
